(() => {
	angular
		.module('main')
		.controller('CompanyInformationController', CompanyInformationController);

	CompanyInformationController.$inject = ['$scope', '$routeParams'];

	function CompanyInformationController($scope, $routeParams) {
		$scope.$on('$viewContentLoaded', () => {
			$scope.companyId = +$routeParams.companyId;
		});
	}
})();



// WEBPACK FOOTER //
// ./web/js/controllers/settings/companyInformationController.js